var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRestore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-restore",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7192",
    "data-name": "Grupo 7192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4433",
    "data-name": "Path 4433",
    d: "M64.17,8.51H49.68V5.33A5.34,5.34,0,0,0,44.35,0H27.62a5.34,5.34,0,0,0-5.33,5.33V8.51H7.8a5.55,5.55,0,0,0-5.54,5.55V16.6A5.55,5.55,0,0,0,7.8,22.15H9.51v42A7.84,7.84,0,0,0,17.35,72h37.3a7.84,7.84,0,0,0,7.84-7.84h0v-42H64.2a5.54,5.54,0,0,0,5.54-5.55V14.06a5.55,5.55,0,0,0-5.56-5.55ZM13,22.14H59v42a4.36,4.36,0,0,1-4.35,4.34H17.33A4.35,4.35,0,0,1,13,64.16ZM46.19,5.32V8.51H25.78V5.32a1.84,1.84,0,0,1,1.84-1.84H44.35a1.84,1.84,0,0,1,1.84,1.84ZM5.74,14.06A2.07,2.07,0,0,1,7.81,12H64.17a2.07,2.07,0,0,1,2.06,2.07V16.6a2.06,2.06,0,0,1-2.06,2H7.81a2.06,2.06,0,0,1-2.07-2Z",
    transform: "translate(0)",
    fill: "#00afc9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3142",
    "data-name": "Rect\\xE1ngulo 3142",
    width: 72,
    height: 72,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9689",
    "data-name": "Grupo 9689",
    transform: "translate(21.956 28.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6867",
    "data-name": "Trazado 6867",
    d: "M1247.7,2175.086a1.733,1.733,0,0,0,1.209-.491l9.356-9.082v25.264a1.737,1.737,0,1,0,3.473,0v-25.264l9.356,9.082a1.737,1.737,0,1,0,2.419-2.492l-12.3-11.939c-.025-.025-.055-.043-.081-.065s-.055-.047-.084-.067-.046-.043-.071-.061l-.023-.013c-.042-.027-.088-.048-.133-.073s-.109-.06-.167-.084a1.42,1.42,0,0,0-.163-.051,1.037,1.037,0,0,0-.115-.035l-.015-.006-.03,0c-.061-.01-.123-.014-.184-.019-.043,0-.085-.012-.127-.012l-.017,0-.013,0c-.061,0-.122.011-.183.017-.043,0-.085.007-.128.014l-.03,0a1.558,1.558,0,0,0-.171.052c-.041.013-.082.022-.123.039a1.976,1.976,0,0,0-.185.093c-.04.022-.08.04-.118.064l-.022.013c-.034.022-.062.053-.094.077s-.044.035-.065.055a.741.741,0,0,0-.079.063l-12.3,11.939a1.737,1.737,0,0,0,1.209,2.983Z",
    transform: "translate(-1245.968 -2159.671)",
    fill: "#00afc9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10894",
    "data-name": "Trazado 10894",
    d: "M0,46.5",
    transform: "translate(35.5 22)",
    stroke: "#707070",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRestore);
export default __webpack_public_path__ + "static/media/icon-restore.66e3205f9d73e52f6eed3531e0b7e2e7.svg";
export { ForwardRef as ReactComponent };